<template>
  <div>
    <data-table :service="EmailScheduleService"
                :entity="entity"
                :columns="columns"
                :disablePermissionChecks="true"
                operations="add,refresh,delete"
                ref="table">
      <template v-slot:subject="{row}">
        {{row.subject}}
      </template>
    </data-table>
  </div>
</template>
<script>
import EmailScheduleService from 'src/services/EmailScheduleService';
import entities from 'src/config/entities';
import Badge from 'src/components/Badge'

export default {
  name: 'email-schedule-list',
  components: {
    Badge,
  },
  data() {
    return {
      EmailScheduleService,
      entity: entities.EMAIL_SCHEDULE
    }
  },
  computed: {
    columns() {
      return  [
        {
          prop: "name",
          label: this.$t('generic.name'),
          minWidth: "150px",
          sortable: true
        },
        {
          prop: "target_event",
          label: this.$t('settings.emails-schedule.targetEvent'),
          minWidth: "150px",
          sortable: true
        },
        {
          prop: "frequency_option",
          label: this.$t('settings.emails-schedule.frequency'),
          minWidth: "150px",
          sortable: true
        }
      ]
    }
  }
}
</script>
<style scoped>
</style>
